<template>
  <b-modal
    ref="modal"
    title="Hủy yêu cầu"
    @ok="handleSubmit"
    ok-title="Xác nhận"
    cancel-title="Hủy"
    :ok-disabled="submitting || !isFormValid"
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="form-group">
      <label for="cancelReason">Lý do hủy <span class="text-danger">*</span></label>
      <textarea
        id="cancelReason"
        v-model="reason"
        class="form-control"
        rows="4"
        placeholder="Nhập lý do hủy"
      ></textarea>
      <div v-if="reasonError" class="invalid-feedback d-block">{{ reasonError }}</div>
      <small class="form-text text-muted mt-2" style="font-size: 14px">
        Lưu ý: Sau khi hủy, yêu cầu sẽ được đánh dấu là "Đã hủy" và không thể khôi phục. Vui lòng
        kiểm tra kỹ trước khi xác nhận. Liên hệ bộ phận hỗ trợ nếu cần.
      </small>
    </div>
  </b-modal>
</template>

<script>
  import { ComboService } from '@/services/combo.service'
  import { showMess } from '@/config/utils'

  export default {
    name: 'CancelPackagePopup',
    props: {
      id: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        reason: '',
        submitting: false,
        reasonError: '',
      }
    },
    computed: {
      isFormValid() {
        return this.reason && this.reason.trim()
      },
    },
    methods: {
      show(initialData = {}) {
        this.reason = ''
        this.reasonError = ''
        this.submitting = false
        this.$nextTick(() => {
          this.$refs.modal && this.$refs.modal.show()
        })
      },
      async handleSubmit() {
        if (!this.isFormValid) {
          this.reasonError = 'Vui lòng nhập lý do hủy'
          return
        }
        this.submitting = true
        try {
          const res = await ComboService.cancelPackage({ id: this.id, reason: this.reason })
          if (res && res.code === 1000) {
            showMess(
              this,
              'Thành công',
              'Hủy yêu cầu thành công',
              'success',
              'b-toaster-top-right',
              3000
            )
            this.$emit('cancelled')
            this.$refs.modal && this.$refs.modal.hide()
          } else {
            this.$emit('error', res)
          }
        } catch (e) {
          showMess(
            this,
            'Lỗi',
            e?.message || 'Có lỗi xảy ra',
            'danger',
            'b-toaster-top-right',
            5000
          )
          this.$emit('error', e)
        } finally {
          this.submitting = false
        }
      },
    },
  }
</script>

<style scoped></style>
